import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { ChakraProvider } from '@chakra-ui/core';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import config from './config/config';
import * as serviceWorker from './serviceWorker';
import store from './store';
import theme from './theme';

Bugsnag.start({
  apiKey: 'ef74bcf0509b6015c10ec8ee16882f32',
  plugins: [new BugsnagPluginReact()],
});

// @ts-ignore
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

ReactDOM.render(
  <ErrorBoundary>
    <ChakraProvider resetCSS theme={theme}>
      <Provider store={store}>
        <Router basename={config.basename}>
          <App />
        </Router>
      </Provider>
    </ChakraProvider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
